import { useRef, useState, useEffect } from "react";

export default function useScrollPercentage(scrollRef, reportPercentage = 5, reportPixels = 400) {
  // const scrollRef = useRef(null);
  const timeoutRef = useRef(null);
  const [scrollState, setScrollPercentage] = useState({ scrollPercentage: NaN, scrollDirection: '', scrollTop: 0 });
  // let timeout_id



  useEffect(() => {
    function reportScroll(e) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
      if (!e.target) return
      let scrollHeight = e.target.scrollHeight
      let clientHeight = e.target.clientHeight
      let scrollTop = e.target.scrollTop
      timeoutRef.current = setTimeout(() => {
  
        // clearTimeout(timeout_id)
  
        // timeout_id = setTimeout(()=>{ 
        const sp = getScrollPercentage(scrollHeight, clientHeight, scrollTop)
  
        if ((sp !== scrollState.scrollPercentage && sp % reportPercentage === 0) || Math.abs(scrollState.scrollTop - scrollTop) > reportPixels) {
          setScrollPercentage({
            scrollPercentage: sp,
            scrollDirection: getScrollDirection(sp, scrollState.scrollPercentage, scrollState.scrollDirection),
            scrollTop: scrollTop
          });
        }
        // } , 50)
      }, 50)
    }

    const node = scrollRef && scrollRef.current;
    if (node) {
      node.addEventListener("scroll", reportScroll, { passive: true });

    }
    return () => {
      if (node) {
        node.removeEventListener("scroll", reportScroll, false);
      }
    };
  }, [scrollState, reportPercentage, reportPixels])
  // console.log('running through useScroll')
  return [scrollRef, Number.isNaN(scrollState.scrollPercentage) ? 0 : scrollState.scrollPercentage, scrollState.scrollDirection, scrollState.scrollTop];
}

function getScrollDirection(newScroll, oldScroll, direction) {
  if (newScroll === oldScroll) return direction
  return newScroll > oldScroll ? 'down' : 'up'
}

function getScrollPercentage(scrollHeight, clientHeight, scrollTop) {
  // if (element === null) {
  //   return NaN;
  // }
  const height = scrollHeight - clientHeight;
  return Math.round((scrollTop / height) * 100);
}